/**
 * KAN-737: shared bits of the dashboard funnel block (row and legend).
 */

/** Colors of the three bar segments; the legend uses the same classes. */
export const SEGMENT_COLORS = {
  moved_on: 'bg-blue-200',
  here: 'bg-blue-600',
  refused: 'bg-red-400',
} as const

/** Percent value 0..100 as text; null as "-". */
export function formatPercent(value: number | null): string {
  if (value === null) return '-'
  return `${Number.isInteger(value) ? value : value.toFixed(1)}%`
}

/** "дошли N · X%"; an entry stage shows no percent (it is ~100% and says nothing). */
export function formatReached(reached: number, conversion: number | null, isEntry: boolean): string {
  if (isEntry) return `дошли ${reached}`
  return `дошли ${reached} · ${formatPercent(conversion)}`
}

/** "отказ M · Y%"; with no refusals just "отказ 0". */
export function formatRefused(refused: number, refusalPct: number | null): string {
  if (refused === 0) return 'отказ 0'
  return `отказ ${refused} · ${formatPercent(refusalPct)}`
}
